const __WEBPACK_NAMESPACE_OBJECT__ = require("@microsoft/applicationinsights-react-js");